import { fiberHexStd, HEX_BY_NAME } from "./spliceUtils";

export function SpliceColumns({ columns, colX, fiberY, armed, isOcc, clickFiber, onFiberHover, onFiberLeave, dirText, t, settings }) {
  return columns.map((col, i) => {
    const c = col.cable;
    const x = colX(i);
    const cnt = Number(c.fiber_count || 12);
    const sideLabel = col.side === "A" ? "WE" : col.side === "B" ? "WY" : "";
    const dir = col.side === "B" ? dirText(col.end, "right") : dirText(col.end, "left");
    return (
      <g key={`col-${c.id}-${col.side || "S"}`}>
        {dir ? <text x={x} y={16} textAnchor="middle" fontSize="7" fill="#7dd3fc">{dir.length > 26 ? dir.slice(0, 25) + "…" : dir}</text> : null}
        <line x1={x} y1={58} x2={x} y2={fiberY(cnt)} stroke="#475569" strokeWidth="2" />
        <text x={x} y={34} textAnchor="middle" fontSize="10" fontWeight="700" fill="#e2e8f0">{c.number}</text>
        {sideLabel ? <text x={x} y={48} textAnchor="middle" fontSize="8" fontWeight="700" fill={col.side === "A" ? "#34d399" : "#fbbf24"}>{sideLabel}</text> : null}
        {Array.from({ length: cnt }, (_, k) => k + 1).map((n) => {
          const occ = isOcc(c, n);
          const isArmed = armed && armed.cableId === c.id && armed.fiber === n && armed.side === col.side;
          const ff = (c.fibers || []).find((x2) => Number(x2.number) === n);
          const lead = ff && ff.leads_to;
          const fpt = Number(c.fibers_per_tube) || 0;
          const tube = fpt > 0 ? Math.floor((n - 1) / fpt) + 1 : 0;
          const totalTubes = fpt > 0 ? Math.ceil(cnt / fpt) : 0;
          const tubeCol = (c.tube_colors && c.tube_colors[tube - 1] && HEX_BY_NAME[c.tube_colors[tube - 1]]) || fiberHexStd(settings, c, tube);
          const fibCol = fiberHexStd(settings, c, n);
          return (
            <g key={n} onClick={() => clickFiber(c, n, col.side)}
              onMouseEnter={(e) => onFiberHover && onFiberHover(c, n, e)}
              onMouseLeave={() => onFiberLeave && onFiberLeave()}
              style={{ cursor: "pointer" }} data-testid={`fiber-${c.id}-${col.side || "S"}-${n}`}>
              <title>{c.number}/{n}{sideLabel ? ` [${sideLabel}]` : ""}{tube && totalTubes > 1 ? ` [tuba ${tube}]` : ""}{lead ? ` → ${lead}` : ` — ${occ ? t("zajęte") : t("wolne")}`}</title>
              {tube && totalTubes > 1 ? <rect x={x - 15} y={fiberY(n) - 3.5} width="4" height="7" rx="1" fill={tubeCol} /> : null}
              <circle cx={x} cy={fiberY(n)} r="5.5" fill={occ ? fibCol : "#0b1120"} stroke={isArmed ? "#22d3ee" : fibCol} strokeWidth={isArmed ? 3 : 1.5} />
              <text x={x + 10} y={fiberY(n) + 3} fontSize="8" fill="#94a3b8">{n}</text>
            </g>
          );
        })}
      </g>
    );
  });
}
